import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const SearchResultTest = lazy(() => import("@/pages/SearchResultTest"));

export const Route = createFileRoute("/sokresultat-test")({
  head: () => ({
    meta: [
      { title: "Testvy sökresultat » Elmarknad.se" },
      { name: "robots", content: "noindex, nofollow" },
      { name: "googlebot", content: "noindex, nofollow" },
      { name: "description", content: "Intern testvy av sökresultatet." },
      { property: "og:title", content: "Testvy sökresultat" },
      { property: "og:description", content: "Intern testvy av sökresultatet." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: () => <SearchResultTest />,
});
